<template>
  <div>
    <BannerView />
    <RankingView />
    <ProgramsView />
    <WhyyouView />
    <CollaborationsView />
    <ItalladdsView />
    <CertificateVue />
    <HiringPartnerVue />
    <OurAlumnaiVue />
    <AdmissionView />
    <DestinationView />
    <!-- <WhatsappIcon /> -->
    <!-- <ChatBotView /> -->
  </div>
</template>

<script>
import BannerView from "../components/LPnew/BannerView.vue";
import RankingView from "../components/LPnew/RankingView.vue";
import WhyyouView from "../components/LPnew/WhyyouView.vue";
import CollaborationsView from "../components/LPnew/CollaborationsView.vue";
import ItalladdsView from "../components/LPnew/ItalladdsView.vue";
import ProgramsView from "../components/LPnew/ProgramsView.vue";
import DestinationView from "../components/LPnew/DestinationView.vue";
import AdmissionView from "../components/LPnew/AdmissionView.vue";
import CertificateVue from "@/components/LPnew/Certificate.vue";
import HiringPartnerVue from "@/components/LPnew/HiringPartner.vue";
import OurAlumnaiVue from "@/components/LPnew/OurAlumnai.vue";
// import WhatsappIcon from "@/components/LandingPage/IconView.vue";
// import ChatBotView from "@/components/ChatBot.vue"
export default {
  name: "LpnewView",
  components: {
    BannerView,
    RankingView,
    WhyyouView,
    CollaborationsView,
    ItalladdsView,
    ProgramsView,
    AdmissionView,
    DestinationView,
    CertificateVue,
    HiringPartnerVue,
    OurAlumnaiVue,
    // WhatsappIcon,
    // ChatBotView,
  },
};
</script>

<style></style>
